<template>
	<PublicMenuLayoutV2>
		<template v-slot:nav-btn-items>
			<b-nav-item class="d-none d-desktop-block d-xl-block">
				<base-button blue @click="goToContactForm"><span>{{ $t('os360-empresas.more-info-btn') }}</span>
					<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2"
						color="white" />
				</base-button>
			</b-nav-item>
			<b-nav-item class="d-none d-desktop-block d-xl-block" :href="$helpers.get360AppUrl('inicio-sesion')">
				<base-button white shadow bold>{{ $t('login.sign-in') }}</base-button>
			</b-nav-item>
		</template>
	</PublicMenuLayoutV2>
</template>

<script>
import PublicMenuLayoutV2 from '@/components/layouts/PublicMenuLayoutV2'
import { BNavItem } from 'bootstrap-vue'
import gtagMixin from '@/mixins/gtag.mixin'

export default {
	name: 'OpensaludEmpresasLayout',
	mixins: [gtagMixin],
	components: {
		BNavItem,
		PublicMenuLayoutV2
	},
	methods: {
		goToContactForm () {
			var contactFormElement = document.getElementById('contact-form')
			if (contactFormElement) {
				contactFormElement.scrollIntoView({ behavior: 'smooth' })
			} else {
				this.$router.push('/opensalud360/contacto')
			}
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layouts/OpensaludEmpresasLayout.vue